/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Achievement_Night_OwlInputs */

const en_us2_achievement_night_owl = /** @type {(inputs: Achievement_Night_OwlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Night owl`)
};

const pt_br2_achievement_night_owl = /** @type {(inputs: Achievement_Night_OwlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coruja`)
};

const es_419_achievement_night_owl = /** @type {(inputs: Achievement_Night_OwlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Búho`)
};

const pt_pt2_achievement_night_owl = /** @type {(inputs: Achievement_Night_OwlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coruja`)
};

const fr_fr2_achievement_night_owl = /** @type {(inputs: Achievement_Night_OwlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oiseau de nuit`)
};

const de_de2_achievement_night_owl = /** @type {(inputs: Achievement_Night_OwlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachteule`)
};

const it_it2_achievement_night_owl = /** @type {(inputs: Achievement_Night_OwlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nottambulo`)
};

/**
* | output |
* | --- |
* | "Night owl" |
*
* @param {Achievement_Night_OwlInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const achievement_night_owl = /** @type {((inputs?: Achievement_Night_OwlInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Achievement_Night_OwlInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_achievement_night_owl(inputs)
	if (locale === "es-419") return es_419_achievement_night_owl(inputs)
	if (locale === "pt-PT") return pt_pt2_achievement_night_owl(inputs)
	if (locale === "fr-FR") return fr_fr2_achievement_night_owl(inputs)
	if (locale === "de-DE") return de_de2_achievement_night_owl(inputs)
	if (locale === "it-IT") return it_it2_achievement_night_owl(inputs)
	return en_us2_achievement_night_owl(inputs)
});
export { achievement_night_owl as "achievement.night_owl" }